import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo-mark.png";
import { Login_Url, Auth_KEY } from "./Config";
import ButtonLoader from "../components/Loader/ButtonLoader";
import "./Login.css";

function Login() {
  const navigate = useNavigate();

  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!mobileNumber.trim() || !password) {
      setError("Please enter mobile number and password.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${Login_Url}api/users/login`,
        {
          mobile_number: mobileNumber.trim(),
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": Auth_KEY,
          },
        }
      );

      if (response.data.success) {
        sessionStorage.setItem("token", response.data.token);
        sessionStorage.setItem("user", JSON.stringify(response.data.data));
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Invalid credentials.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Invalid credentials. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <aside className="login-brand" aria-hidden="false">
        <div className="login-brand-inner">
          <img src={logo} alt="WEBDOC" className="login-brand-logo" />
          <p className="login-brand-sub">
            Employee portal for reports, call logs, and daily operations.
          </p>
        </div>
      </aside>

      <main className="login-form-side">
        <div className="login-form-card">
          <div className="login-mobile-brand">
            <img src={logo} alt="WEBDOC" />
          </div>

          <h1>Welcome back</h1>
          <p className="login-lead">Sign in with your mobile number to continue</p>

          {error ? (
            <div className="login-alert" role="alert">
              <i className="bi bi-exclamation-triangle-fill" aria-hidden="true" />
              <span>{error}</span>
            </div>
          ) : null}

          <form onSubmit={handleLogin} noValidate>
            <div className="login-input-wrap">
              <label className="login-label" htmlFor="login-mobile">
                Mobile Number
              </label>
              <input
                id="login-mobile"
                type="tel"
                className="login-input"
                placeholder="03001234567"
                autoComplete="username"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                disabled={loading}
              />
            </div>

            <div className="login-input-wrap">
              <label className="login-label" htmlFor="login-password">
                Password
              </label>
              <input
                id="login-password"
                type={showPassword ? "text" : "password"}
                className="login-input login-input-password"
                placeholder="Enter password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <button
                type="button"
                className="login-eye"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                tabIndex={-1}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} />
              </button>
            </div>

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? <ButtonLoader label="Signing in…" /> : "Sign In"}
            </button>
          </form>

          <p className="login-footer-note">Authorized staff access only</p>
        </div>
      </main>
    </div>
  );
}

export default Login;
